import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import HowTo, { TutorialProps } from '../../components/Autocomplete/HowTo';
import Skeleton from '@mui/material/Skeleton';

export default function Training() {
  const [value, setValue] = React.useState<TutorialProps | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [inputValue, setInputValue] = React.useState('');

  React.useEffect(() => {
    if (!value) return;
    setLoading(true);
  }, [value]);

  return (
    <Stack spacing={1}>
      <HowTo
        value={value}
        setValue={setValue}
        inputValue={inputValue}
        setInputValue={setInputValue}
      />
      <Typography variant="caption" fontSize={11} color="text.secondary">
        * If the instruction does not load, close the popup and select again.
        {/* * To view instruction manual on Scribe, click{' '}
        <Link
          href="https://scribehow.com/workspace#documents__giJpoko_QFylAXZLUz87PQ"
          target="_blank"
        >
          here
        </Link> */}
      </Typography>
      <Box
        sx={{ width: '100%', height: 800 }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {loading && <Skeleton variant="rectangular" height={800} width="100%" />}
        {value && (
          <iframe
            title={value?.label}
            src={value?.url}
            style={{
              display: loading ? 'none' : 'block',
              height: '100%',
              width: '100%',
            }}
            allowFullScreen
            loading="lazy"
            onLoad={() => setLoading(false)}
          />
        )}
      </Box>
    </Stack>
  );
}
